"use client";
import type { InteractiveZone } from "@gettactic/helpers/src/map/types";
import React from "react";

export interface MapRoomSelectionBadgeProps {
  zone: InteractiveZone;
  /** 1-based position of the room in the reservation's room list. */
  position: number;
}

const RADIUS = 11;
const OFFSET = 20;

/**
 * Numbered marker drawn on a room that is part of a multi-room reservation, so the
 * map shows the same order as the room list in the reserve card.
 */
export const MapRoomSelectionBadge: React.FC<MapRoomSelectionBadgeProps> = ({
  zone,
  position
}) => {
  if (!zone.circle) {
    return null;
  }

  const cx = (zone.circle.cx ?? 0) + OFFSET;
  const cy = (zone.circle.cy ?? 0) - OFFSET;
  // The zone may be rotated on the floor plan; the badge has to stay upright.
  const counterRotate = zone.rotation
    ? `rotate(${-zone.rotation}, ${zone.circle.cx ?? 0}, ${zone.circle.cy ?? 0})`
    : undefined;

  return (
    <g
      transform={
        zone.mapBuilderContainerTransformation || zone.containerTransformation
      }
      className="map-room-selection-badge"
    >
      <g transform={counterRotate}>
        <circle
          cx={cx}
          cy={cy}
          r={RADIUS}
          className="text-primary"
          fill="currentColor"
          stroke="#ffffff"
          strokeWidth={2}
        />
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          dominantBaseline="central"
          fill="#ffffff"
          fontSize={13}
          fontWeight={700}
        >
          {position}
        </text>
      </g>
    </g>
  );
};
